import { Scale, HeartHandshake, MapPin, Eye, Zap } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { WHY_US } from "../data/content";

const ICONS = { Scale, HeartHandshake, MapPin, Eye, Zap };

export const WarumWir = () => (
  <section className="bg-background py-24 sm:py-32" data-testid="warum-wir-section">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">Warum wir?</p>
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-navy-900 leading-[1.05]">
            Energieberatung, die <span className="font-serif italic text-blue-700">ehrlich</span> bleibt.
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-slate-500 leading-relaxed">
            Kein Callcenter, keine Tariftricks. Sie sprechen direkt mit Ihrer Beraterin – und erhalten eine
            unabhängige Einschätzung, die sich rechnet.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-6">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[item.icon];
          const spans = ["lg:col-span-5", "lg:col-span-7", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];
          return (
            <Reveal key={item.key} delay={i * 0.08} className={spans[i]}>
              <div
                className="group h-full rounded-3xl border border-slate-200 bg-white p-8 sm:p-10 hover:-translate-y-1.5 hover:border-blue-300 transition-[transform,border-color] duration-500 hover:shadow-[0_30px_60px_-30px_rgba(29,78,216,0.25)]"
                data-testid={`why-card-${item.key}`}
              >
                <span className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-blue-50 text-blue-700 mb-6 group-hover:bg-blue-700 group-hover:text-white transition-colors duration-500">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="text-2xl font-heading font-normal text-navy-900 mb-3">{item.title}</h3>
                <p className="text-slate-500 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
